module.exports = __webpack_public_path__ + "9dc7e106702e79e15549624f11005ed3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/shield-s.png
// module id = 2606
// module chunks = 0